import { useRef } from 'react';
import './view.css';
import { getViewComment } from '../../utils/testing_teacher_document'; // 필터링된 댓글 가져오기 함수

const TestingTeacherDocumentView = ({ testingTeacherDocumentObj, onClose }) => {
  const printRef = useRef(null);

  // testingTeacherDocumentObj.comment를 console.log로 출력
  console.log('testingTeacherDocumentObj:', testingTeacherDocumentObj);

  const handlePrint = () => {
    if (printRef.current) {
      const printContents = printRef.current.innerHTML;
      const win = window.open('', '', 'width=800,height=600');
      const html = `
        <html>
          <head>
            <title>문서 인쇄</title>
            <link rel="stylesheet" type="text/css" href="${window.location.origin}/src/pages/testing_teacher_document/view.css">
            <style>
              body { 
                background: none !important;
                margin: 0; padding: 0;
              }
              
              div.page {
                width: 210mm !important;
                min-height: 297mm !important;
                padding: 20mm 15mm !important;
                margin: 0 auto !important;
                background: #fff !important;
                border: none !important;
                box-shadow: none !important;
                border-radius: 0 !important;
                page-break-after: always;
                box-sizing: border-box;
                position: relative;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                align-items: center;
                page-break-after: always;
              }

              div.page > h1 {
                font-size: 2em;
                margin: 25px 0;
              }

              div.page > table:nth-child(2) {
                width:80%;
                margin:4em 25%;
              }

              div.page > table:nth-child(2) > tbody > tr > th {
                width: calc(25% - 1em);
                text-align: right;
                padding: 0.5em;
                font-size:1.2em;
              }

              div.page > table:nth-child(2) > tbody > tr > td {
                width: calc(25% - 1em);
                text-align: left;
                padding: 0.5em;
                font-size:1.2em;
              }

              div.page > table:nth-child(2) > tbody > tr:nth-child(3) > td {
                width:calc(100% - 3em);
                text-align: left;
                word-break: break-all;
                padding: 1.5em;
                line-height: 23px;
                font-size:1.2em;
              }

              div.page > table:nth-child(3) {
                width: 60%;
                margin: 2.5em 20%;
              }

              div.page > table:nth-child(3) tbody tr th, div.page > table:nth-child(3) tbody tr td {
                text-align:center;
                padding: 10px 5px;
                line-height:20px;
              }

              div.page > table:nth-child(3) > tbody > tr:nth-child(1) > th {
                text-align:right;
              }

              div.page > table:nth-child(3) > tbody > tr:nth-child(1) > td {
                text-align:left;
              }

              div.page > table:nth-child(4) > tbody > tr > th, div.page > table:nth-child(4) > tbody > tr > td {
                text-align: center;
                vertical-align: middle;
                padding:35px 0;
                line-height:40px;
                font-size: 1.2em;
              }

              div.page > table:nth-child(4) > tbody > tr:nth-child(2) > th {
                text-align: right;
              }

              div.page > table:nth-child(4) > tbody > tr > th img {
                height: 40px;
                vertical-align: middle;
              }
            </style>
          </head>
          <body>${printContents}</body>
        </html>
      `;
      console.log(html);
      win.document.write(html);
      win.document.close();
      win.focus();
      win.print();
      win.close();
    }
  };

  return (
    <div id="testing_teacher_document_view">
      <div className="head">
        <h1>{ testingTeacherDocumentObj.title } 내용보기</h1>
      </div>
      <div className="body" ref={printRef}>
        <div
          id="page1"
          className="page"
          dangerouslySetInnerHTML={{ __html: getViewComment(testingTeacherDocumentObj.comment) }}
        />
      </div>
      <div className="foot">
        <button onClick={handlePrint}>인쇄</button>
        <button onClick={onClose}>닫기</button>
      </div>
    </div>
  );
}

export default TestingTeacherDocumentView;